/* Not loaded on the storefront: the theme loads esp-image-detail.min.js, a copy of this file. Shopify re-minifies .js assets into syntax iOS 13.0-13.3 cannot run, and serves .min.js files as they are. Make changes in esp-image-detail.min.js. */
(() => {
  if (window.espImageDetailReady) return;
  let labels;
  try {
    var _document$getElementB;
    labels = JSON.parse(((_document$getElementB = document.getElementById('esp-image-detail-settings')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.textContent) || 'null');
  } catch {
    return;
  }
  const keys = ['open', 'close', 'label', 'viewport', 'loading', 'error', 'retry', 'fit', 'actual', 'zoom_in', 'zoom_out', 'pan_left', 'pan_right', 'pan_up', 'pan_down', 'zoom_status', 'position_status'];
  if (!labels || keys.some(key => typeof labels[key] !== 'string' || !labels[key].trim())) return;
  window.espImageDetailReady = true;
  const ownedSelector = '[data-esp-image-detail-root]';
  const imageSelector = '.mz-image-stage .mz-figure > img';
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const owned = node => {
    var _node$parentElement;
    return Boolean((node === null || node === void 0 ? void 0 : node.nodeType) === 1 ? node.closest(ownedSelector) : node === null || node === void 0 || (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest(ownedSelector));
  };
  const external = record => !owned(record.target) && !(record.type === 'childList' && [...record.addedNodes, ...record.removedNodes].length && [...record.addedNodes, ...record.removedNodes].every(owned));
  const safeURL = value => {
    try {
      const url = new URL(value, document.baseURI);
      if (url.protocol !== 'https:' || url.username || url.password || url.port && url.port !== '443') return null;
      if (url.origin !== location.origin && url.hostname !== 'cdn.shopify.com') return null;
      if (!/\.(?:jpe?g|png|webp|gif|avif)$/i.test(url.pathname) || /svg/i.test(url.searchParams.get('format') || '')) return null;
      return url.href;
    } catch {
      return null;
    }
  };
  const displayed = element => (element === null || element === void 0 ? void 0 : element.isConnected) && getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden';
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    if (text) element.textContent = text;
    return element;
  };
  let sequence = 0,
    current = null,
    frame = 0;
  class ImageDetail {
    constructor(viewer) {
      this.viewer = viewer;
      this.opened = false;
      this.ready = false;
      this.token = 0;
      this.center = {
        x: 0.5,
        y: 0.5
      };
      this.listeners = new AbortController();
      this.root = make('div', 'esp-image-detail');
      this.root.setAttribute('data-esp-image-detail-root', '');
      this.trigger = make('button', 'esp-image-detail-open', labels.open);
      this.trigger.type = 'button';
      this.trigger.setAttribute('aria-expanded', 'false');
      this.panel = make('section', 'esp-image-detail-panel');
      this.panel.id = `esp-image-detail-panel-${++sequence}`;
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-controls', this.panel.id);
      const title = make('h2', 'esp-image-detail-title', labels.label);
      title.id = `${this.panel.id}-title`;
      this.panel.setAttribute('aria-labelledby', title.id);
      const zoom = make('div', 'esp-image-detail-toolbar');
      const pan = make('div', 'esp-image-detail-toolbar');
      this.buttons = {};
      const button = (key, parent, action) => {
        const control = make('button', `esp-image-detail-${key}`, labels[key]);
        control.type = 'button';
        control.dataset.imageDetailAction = key;
        control.addEventListener('click', () => {
          if (control.getAttribute('aria-disabled') !== 'true') action();
        }, {
          signal: this.listeners.signal
        });
        parent.append(control);
        this.buttons[key] = control;
      };
      button('zoom_in', zoom, () => this.setScale(this.scale * 1.5));
      button('zoom_out', zoom, () => this.setScale(this.scale / 1.5));
      button('fit', zoom, () => {
        this.fit = true;
        this.center = {
          x: 0.5,
          y: 0.5
        };
        this.render();
      });
      button('actual', zoom, () => this.setScale(1));
      this.viewport = make('div', 'esp-image-detail-viewport');
      this.viewport.tabIndex = 0;
      this.viewport.setAttribute('role', 'region');
      this.viewport.setAttribute('aria-label', labels.viewport);
      this.canvas = make('div', 'esp-image-detail-canvas');
      this.viewport.append(this.canvas);
      button('pan_left', pan, () => this.pan(-1, 0));
      button('pan_right', pan, () => this.pan(1, 0));
      button('pan_up', pan, () => this.pan(0, -1));
      button('pan_down', pan, () => this.pan(0, 1));
      this.status = make('p', 'esp-image-detail-status');
      this.status.setAttribute('role', 'status');
      this.status.setAttribute('aria-live', 'polite');
      this.status.setAttribute('aria-atomic', 'true');
      const actions = make('div', 'esp-image-detail-toolbar');
      button('retry', actions, () => this.load(true));
      this.buttons.retry.hidden = true;
      button('close', actions, () => this.close());
      this.panel.append(title, zoom, this.viewport, pan, this.status, actions);
      this.root.append(this.trigger, this.panel);
      viewer.append(this.root);
      this.trigger.addEventListener('click', () => this.open(), {
        signal: this.listeners.signal
      });
      for (const type of ['pointerdown', 'pointerup', 'pointermove', 'mousedown', 'mouseup', 'mousemove', 'touchstart', 'touchend', 'touchmove', 'wheel', 'click', 'dblclick']) {
        this.root.addEventListener(type, event => event.stopPropagation(), {
          passive: true,
          signal: this.listeners.signal
        });
      }
      this.viewport.addEventListener('keydown', event => {
        if (!event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey && ['ArrowLeft', 'ArrowRight'].includes(event.key)) event.stopPropagation();
      }, {
        signal: this.listeners.signal
      });
      this.viewport.addEventListener('scroll', () => {
        if (!this.ready) return;
        const expected = this.programmaticPosition;
        this.programmaticPosition = null;
        if (expected && Math.abs(this.viewport.scrollLeft - expected.left) < 1 && Math.abs(this.viewport.scrollTop - expected.top) < 1) return;
        this.rememberCenter();
        this.updateButtons();
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          if (this.opened && this.ready) this.announce();
        }, 150);
      }, {
        passive: true,
        signal: this.listeners.signal
      });
      this.resize = () => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => {
          if (!this.opened) return;
          if (this.ready) this.render(this.announcedImageIdentity);
          this.revealFocusedControl();
        });
      };
      window.addEventListener('resize', this.resize, {
        signal: this.listeners.signal
      });
      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(this.resize);
        this.resizeObserver.observe(this.viewport);
      }
      this.sourceObserver = new MutationObserver(records => {
        if (records.some(external)) this.syncSource();
      });
      this.sourceObserver.observe(viewer, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'sizes', 'alt']
      });
      this.visibilityObserver = new MutationObserver(schedule);
      this.visibilityObserver.observe(viewer, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
      this.syncSource();
    }
    syncSource() {
      var _this$source;
      const node = [...this.viewer.querySelectorAll(imageSelector)].find(image => !owned(image));
      const url = safeURL((node === null || node === void 0 ? void 0 : node.getAttribute('src')) || (node === null || node === void 0 ? void 0 : node.currentSrc) || '');
      const alt = (node === null || node === void 0 ? void 0 : node.getAttribute('alt')) || '';
      if (url === ((_this$source = this.source) === null || _this$source === void 0 ? void 0 : _this$source.url)) {
        if (this.image) this.image.alt = alt;
        if (this.source) this.source.alt = alt;
        return;
      }
      this.source = url ? {
        url,
        alt
      } : null;
      if (this.opened) this.load(true);
    }
    open() {
      if (this.opened) return;
      this.opened = true;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.trigger.hidden = true;
      this.panel.hidden = false;
      this.panel.scrollTop = 0;
      this.panel.scrollLeft = 0;
      this.viewer.setAttribute('data-esp-image-detail-open', '');
      this.buttons.zoom_in.focus({
        preventScroll: true
      });
      this.syncSource();
      this.load();
    }
    cancelImage() {
      this.token++;
      if (this.image) {
        this.image.onload = null;
        this.image.onerror = null;
        this.image.removeAttribute('src');
      }
      this.image = null;
      this.ready = false;
      this.viewport.removeAttribute('aria-busy');
      this.canvas.replaceChildren();
      this.canvas.removeAttribute('style');
      this.box = null;
      this.programmaticPosition = null;
      clearTimeout(this.scrollTimer);
      cancelAnimationFrame(this.resizeFrame);
    }
    load(force = false) {
      if (!this.opened || !force && this.image) return;
      const retryFocused = document.activeElement === this.buttons.retry;
      this.cancelImage();
      this.fit = true;
      this.center = {
        x: 0.5,
        y: 0.5
      };
      this.buttons.retry.hidden = !retryFocused;
      this.buttons.retry.setAttribute('aria-disabled', 'true');
      this.updateButtons();
      if (!this.source) {
        this.fail();
        return;
      }
      const token = this.token,
        source = this.source;
      const image = make('img', 'esp-image-detail-image');
      image.alt = source.alt;
      image.draggable = false;
      image.hidden = true;
      this.image = image;
      this.canvas.append(image);
      this.viewport.setAttribute('aria-busy', 'true');
      this.setStatus(labels.loading);
      image.onload = () => {
        if (!this.opened || token !== this.token || this.image !== image) return;
        if (!image.naturalWidth || !image.naturalHeight) {
          this.fail();
          return;
        }
        this.natural = {
          width: image.naturalWidth,
          height: image.naturalHeight
        };
        this.ready = true;
        this.viewport.removeAttribute('aria-busy');
        image.hidden = false;
        const restoreRetry = document.activeElement === this.buttons.retry;
        this.buttons.retry.hidden = true;
        this.buttons.retry.removeAttribute('aria-disabled');
        this.render(true);
        if (restoreRetry) this.viewport.focus({
          preventScroll: true
        });
      };
      image.onerror = () => {
        if (this.opened && token === this.token && this.image === image) this.fail();
      };
      image.src = source.url;
    }
    fail() {
      this.ready = false;
      this.viewport.removeAttribute('aria-busy');
      if (this.image) this.image.hidden = true;
      this.setStatus(labels.error);
      this.buttons.retry.hidden = false;
      this.buttons.retry.removeAttribute('aria-disabled');
      this.updateButtons();
    }
    fitScale() {
      return Math.min(1, this.viewport.clientWidth / this.natural.width, this.viewport.clientHeight / this.natural.height);
    }
    setScale(scale) {
      if (!this.ready) return;
      this.rememberCenter();
      this.scale = clamp(scale, this.fitScale(), 4);
      this.fit = Math.abs(this.scale - this.fitScale()) < 0.0001;
      this.render();
    }
    render(announceImage = false) {
      if (!this.ready || !this.opened || !this.viewport.clientWidth || !this.viewport.clientHeight) return;
      const width = this.viewport.clientWidth,
        height = this.viewport.clientHeight;
      this.scale = this.fit ? this.fitScale() : clamp(this.scale, this.fitScale(), 4);
      const imageWidth = this.natural.width * this.scale,
        imageHeight = this.natural.height * this.scale;
      this.box = {
        width,
        height,
        imageWidth,
        imageHeight
      };
      this.image.style.width = `${imageWidth}px`;
      this.image.style.height = `${imageHeight}px`;
      this.canvas.style.width = `${Math.max(width, imageWidth)}px`;
      this.canvas.style.height = `${Math.max(height, imageHeight)}px`;
      this.scrollTo(this.center.x * imageWidth - width / 2, this.center.y * imageHeight - height / 2);
      this.updateButtons();
      this.announce(announceImage);
    }
    limits() {
      var _this$box, _this$box2;
      return {
        x: Math.max(0, (((_this$box = this.box) === null || _this$box === void 0 ? void 0 : _this$box.imageWidth) || 0) - this.viewport.clientWidth),
        y: Math.max(0, (((_this$box2 = this.box) === null || _this$box2 === void 0 ? void 0 : _this$box2.imageHeight) || 0) - this.viewport.clientHeight)
      };
    }
    revealFocusedControl() {
      const target = document.activeElement;
      if (!this.opened || !this.panel.contains(target) || target.closest('[hidden], [inert]') || !displayed(target)) return;
      const panel = this.panel.getBoundingClientRect(),
        control = target.getBoundingClientRect();
      if (!panel.width || !control.width || !control.height) return;
      const top = Math.max(0, panel.top + this.panel.clientTop) + 4;
      const bottom = Math.min(window.innerHeight, panel.top + this.panel.clientTop + this.panel.clientHeight) - 4;
      if (bottom <= top) return;
      let delta = 0;
      if (control.height <= bottom - top) {
        if (control.top < top) delta = control.top - top;else if (control.bottom > bottom) delta = control.bottom - bottom;
      } else {
        if (control.top > top) delta = control.top - top;else if (control.bottom < bottom) delta = control.bottom - bottom;
      }
      if (delta) this.panel.scrollTop = clamp(this.panel.scrollTop + delta, 0, Math.max(0, this.panel.scrollHeight - this.panel.clientHeight));
    }
    scrollTo(left, top) {
      const limits = this.limits();
      clearTimeout(this.scrollTimer);
      this.programmaticPosition = {
        left: clamp(left, 0, limits.x),
        top: clamp(top, 0, limits.y)
      };
      this.viewport.scrollTo({
        ...this.programmaticPosition,
        behavior: 'instant'
      });
      this.rememberCenter();
    }
    rememberCenter() {
      if (!this.box) return;
      const {
        width,
        height,
        imageWidth,
        imageHeight
      } = this.box;
      this.center = {
        x: imageWidth > width ? clamp((this.viewport.scrollLeft + width / 2) / imageWidth, 0, 1) : 0.5,
        y: imageHeight > height ? clamp((this.viewport.scrollTop + height / 2) / imageHeight, 0, 1) : 0.5
      };
    }
    pan(x, y) {
      if (!this.ready) return;
      this.scrollTo(this.viewport.scrollLeft + x * this.viewport.clientWidth * 0.8, this.viewport.scrollTop + y * this.viewport.clientHeight * 0.8);
      this.updateButtons();
      this.announce();
    }
    updateButtons() {
      const limits = this.limits();
      const unavailable = {
        zoom_in: !this.ready || this.scale >= 4,
        zoom_out: !this.ready || this.scale <= (this.ready ? this.fitScale() : 0) + 0.0001,
        fit: !this.ready || this.fit,
        actual: !this.ready || Math.abs(this.scale - 1) < 0.0001,
        pan_left: !this.ready || this.viewport.scrollLeft <= 0.5,
        pan_right: !this.ready || this.viewport.scrollLeft >= limits.x - 0.5,
        pan_up: !this.ready || this.viewport.scrollTop <= 0.5,
        pan_down: !this.ready || this.viewport.scrollTop >= limits.y - 0.5
      };
      for (const [key, disabled] of Object.entries(unavailable)) this.buttons[key].setAttribute('aria-disabled', String(disabled));
    }
    setStatus(text) {
      if (this.status.textContent !== text) this.status.textContent = text;
    }
    announce(includeImage = false) {
      var _this$image;
      if (!this.ready) return;
      this.announcedImageIdentity = includeImage;
      const limits = this.limits();
      const zoom = labels.zoom_status.replaceAll('{percent}', String(Math.round(this.scale * 100)));
      const position = labels.position_status.replaceAll('{horizontal}', String(Math.round(limits.x ? this.viewport.scrollLeft / limits.x * 100 : 50))).replaceAll('{vertical}', String(Math.round(limits.y ? this.viewport.scrollTop / limits.y * 100 : 50)));
      const identity = includeImage && (_this$image = this.image) !== null && _this$image !== void 0 && _this$image.alt ? `${this.image.alt} ` : '';
      this.setStatus(`${identity}${zoom} ${position}`);
    }
    close() {
      if (!this.opened) return;
      this.opened = false;
      this.cancelImage();
      this.panel.hidden = true;
      this.trigger.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.viewer.removeAttribute('data-esp-image-detail-open');
      this.setStatus('');
      this.trigger.focus({
        preventScroll: true
      });
    }
    destroy() {
      var _this$resizeObserver;
      this.opened = false;
      this.cancelImage();
      this.listeners.abort();
      this.sourceObserver.disconnect();
      this.visibilityObserver.disconnect();
      (_this$resizeObserver = this.resizeObserver) === null || _this$resizeObserver === void 0 || _this$resizeObserver.disconnect();
      this.viewer.removeAttribute('data-esp-image-detail-open');
      this.root.remove();
    }
  }
  function reconcile() {
    var _current;
    frame = 0;
    const viewer = document.documentElement.classList.contains('mz-expanded-view-open') ? [...document.querySelectorAll('.mz-expand')].find(displayed) : null;
    if (((_current = current) === null || _current === void 0 ? void 0 : _current.viewer) !== viewer) {
      var _current2;
      (_current2 = current) === null || _current2 === void 0 || _current2.destroy();
      current = null;
    }
    if (viewer && !current) current = new ImageDetail(viewer);
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(reconcile);
  }
  const start = () => {
    new MutationObserver(schedule).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
    new MutationObserver(records => {
      if (records.some(record => external(record) && [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('.mz-expand') || node.querySelector('.mz-expand'))))) schedule();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
    reconcile();
  };
  if (document.body) start();else document.addEventListener('DOMContentLoaded', start, {
    once: true
  });
})();
